// src/components/Feedback.js
import React, { useState } from 'react';
import db from '../firebase/firebaseConfig';
import { doc, setDoc } from 'firebase/firestore';

const Feedback = ({ teamId }) => {
    const [feedback, setFeedback] = useState('');

    const handleSubmit = async () => {
        if (!feedback.trim()) {
            alert('Please enter your feedback.');
            return;
        }
        try {
            const feedbackDoc = doc(db, 'feedback', teamId);
            await setDoc(feedbackDoc, { teamId, feedback }, { merge: true });
            alert('Thank you for your feedback!');
            setFeedback(''); // Clear the input after submission
        } catch (error) {
            console.error('Error submitting feedback:', error);
            alert('Could not submit feedback. Please try again later.');
        }
    };

    return (
        <div style={{ padding: '20px', textAlign: 'start' }}>
            <h2>Please input any feedback on your experience in Cuba</h2>
            <textarea
                value={feedback}
                onChange={(e) => setFeedback(e.target.value)}
                placeholder="Enter your feedback here"
                rows="5"
                style={{ width: '70vw', margin: '10px 0', padding: '10px' }}
            />
            <p> </p>
            <button onClick={handleSubmit}>Submit Feedback</button>
        </div>
    );
};

export default Feedback;
